import { useNavigate } from "react-router-dom";
import usePageMeta from "utils/usePageMeta";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";

import logo from "assets/images/Spechs_logo/logo_no_text_transparent.png";
import bgImage from "assets/images/office2.jpg";

const products = [
  {
    icon: "people",
    title: "Spechs Workforce App",
    buttonLabel: "Learn More",
    route: "/workforce/",
    badge: null,
  },
  {
    icon: "cleaning_services",
    title: "Spechs Cleaning Services",
    buttonLabel: "Learn More",
    route: "/cleaning/",
    badge: null,
  },
  {
    icon: "home_work",
    title: "Spechs Property Services",
    buttonLabel: "Learn More",
    route: "/property/",
    badge: null,
  },
  {
    icon: "sanitizer",
    // icon: "warehouse",
    // icon: "category",
    // icon: "storefront",
    // icon: "local_shipping",
    // icon: "shopping_cart",
    title: "Spechs Supplies",
    buttonLabel: "Learn More",
    route: "/supplies/",
    badge: null,
  },
];

function GatePage() {
  const navigate = useNavigate();
  usePageMeta({
    title: "Spechs | Cleaning, Property Management & Workforce Solutions in Ireland",
    description:
      "Spechs provides professional cleaning, property management, and workforce management solutions across Ireland.",
    canonical: "https://www.spechs.ie/",
  });

  return (
    <MKBox sx={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      {/* Hero */}
      <MKBox
        sx={{
          position: "relative",
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        {/* Dark overlay */}
        <MKBox
          sx={{
            position: "absolute",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.62)",
          }}
        />

        {/* Content */}
        <MKBox sx={{ position: "relative", zIndex: 1, width: "100%", py: { xs: 6, md: 0 } }}>
          <MKBox textAlign="center" mb={{ xs: 6, md: 10 }}>
            <MKBox
              component="img"
              src={logo}
              alt="Spechs"
              sx={{
                height: { xs: 70, md: 100 },
                mb: 3,
                filter: "drop-shadow(0 0 2px rgba(255,255,255))",
              }}
            />
            <MKTypography
              variant="h1"
              color="white"
              fontWeight="bold"
              sx={{ letterSpacing: "-0.5px", mb: 2, fontSize: { xs: "2rem", md: "3rem" } }}
            >
              Welcome to Spechs
            </MKTypography>
            <MKTypography variant="h5" color="white" fontWeight="regular" sx={{ opacity: 0.75 }}>
              What are you looking for today?
            </MKTypography>
          </MKBox>

          {/* Cards */}
          <Container maxWidth="lg">
            <Grid container spacing={3} justifyContent="center">
              {products.map(({ icon, title, buttonLabel, route, badge }) => (
                <Grid item xs={12} sm={6} md={3} key={title}>
                  <MKBox
                    onClick={() => navigate(route)}
                    sx={{
                      background: "rgba(255,255,255,0.08)",
                      backdropFilter: "blur(16px)",
                      WebkitBackdropFilter: "blur(16px)",
                      border: "1px solid rgba(255,255,255,0.5)",
                      borderRadius: 2,
                      p: 4,
                      cursor: "pointer",
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      position: "relative",
                      transition:
                        "transform 0.25s ease, box-shadow 0.25s ease, background 0.25s ease",
                      "&:hover": {
                        transform: "translateY(-6px)",
                        background: "rgba(255,255,255,0.13)",
                        boxShadow: "0 20px 60px rgba(0,0,0,0.4)",
                      },
                    }}
                  >
                    {badge && (
                      <MKBox
                        sx={{
                          position: "absolute",
                          top: 16,
                          right: 16,
                          background: "#344767",
                          borderRadius: 1,
                          px: 1.25,
                          py: 0.4,
                        }}
                      >
                        <MKTypography
                          variant="caption"
                          sx={{ color: "white", fontWeight: 700, fontSize: "0.65rem" }}
                        >
                          {badge}
                        </MKTypography>
                      </MKBox>
                    )}

                    <MKTypography
                      display="block"
                      variant="h1"
                      sx={{
                        color: "rgba(255,255,255,0.6) !important",
                        mb: 2,
                        fontSize: "2.5rem !important",
                      }}
                    >
                      <Icon>{icon}</Icon>
                    </MKTypography>

                    <MKTypography
                      variant="h5"
                      fontWeight="bold"
                      sx={{ color: "white !important", mb: 3 }}
                    >
                      {title}
                    </MKTypography>

                    <MKBox sx={{ flex: 1 }} />

                    <MKButton
                      variant="outlined"
                      fullWidth
                      onClick={() => navigate(route)}
                      sx={{
                        color: "rgba(255,255,255,0.85)",
                        borderColor: "rgba(255,255,255,0.3)",
                        border: "0.5px solid",
                        boxShadow: "none",
                        fontWeight: 600,
                        "&:hover": {
                          background: "rgba(255,255,255,0.15)",
                          borderColor: "rgba(255,255,255,0.5)",
                          color: "#ffffff",
                          boxShadow: "none",
                        },
                      }}
                    >
                      {buttonLabel}
                    </MKButton>
                  </MKBox>
                </Grid>
              ))}
            </Grid>
          </Container>
        </MKBox>

        {/* Footer strip */}
        <MKBox
          sx={{
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 1,
            textAlign: "center",
            py: 2,
          }}
        >
          <MKTypography variant="caption" sx={{ color: "rgba(255,255,255,0.4)" }}>
            © {new Date().getFullYear()} Spechs. All rights reserved.
          </MKTypography>
        </MKBox>
      </MKBox>
    </MKBox>
  );
}

export default GatePage;
